import { Switch } from '@affine/component';
import { EditorSettingService } from '@affine/core/modules/editor-setting';
import { useI18n } from '@affine/i18n';
import { useLiveData, useService } from '@toeverything/infra';

export const CreationLocationSwitch = () => {
  const t = useI18n();
  const { editorSetting } = useService(EditorSettingService);
  const enabled = useLiveData(
    editorSetting.settings$.selector(s => s.captureDocCreationLocation)
  );
  return (
    <Switch
      data-testid="capture-doc-creation-location"
      aria-label={t['com.affine.settings.creation-location.title']()}
      checked={enabled}
      onChange={enabled =>
        editorSetting.set('captureDocCreationLocation', enabled)
      }
    />
  );
};
